import React from 'react';
import {IShippingIntervalOptions, IShopifyData, ISimpleSubProduct} from '../types';
import SimpleSubProduct from './SimpleSubProduct';
import FlameIcon from '../Icons/FlameIcon';

interface SimpleSubMainProps {
  langStrings: Record<string, string>;
  shippingIntervalOptions: IShippingIntervalOptions;
  setShippingIntervalOptions: React.Dispatch<React.SetStateAction<IShippingIntervalOptions>>;
  simpleSubProducts: ISimpleSubProduct[];
  setSimpleSubProducts: React.Dispatch<React.SetStateAction<ISimpleSubProduct[]>>;
  shopifyData: IShopifyData;
}

const SimpleSubMain: React.FunctionComponent<SimpleSubMainProps> = ({
  langStrings,
  shippingIntervalOptions,
  setShippingIntervalOptions,
  simpleSubProducts,
  setSimpleSubProducts,
  shopifyData
}: SimpleSubMainProps) => {
  const { mainContent } = shopifyData.settings;

  const handleFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setShippingIntervalOptions({...shippingIntervalOptions, selectedFrequency: e.target.value});
  };

  return (
    <div className="simple-sub-main">
      <div className="simple-sub-main-heading">
        <h1 className="simple-sub-main-title">
          {mainContent.mainPageTitle}
        </h1>
        <p className="simple-sub-main-desc">{mainContent.mainPageDesc}</p>
      </div>

      <div className="simple-sub-main-sect-one">
        <h3 className="simple-sub-main-sect-num">1</h3>
        <h2 className="simple-sub-main-sect-title">{mainContent.sectionOneTitle}</h2>
        <p className="simple-sub-main-sect-desc">{mainContent.sectionOneDesc}</p>
        <p className="simple-sub-main-sect-info">
          <FlameIcon />
          <span className="simple-sub-main-sect-info-txt">
            {mainContent.sectionOneInfo}
          </span>
        </p>
        <div className="simple-sub-main-products">
          {simpleSubProducts?.map(prod => {
            const commonFreqsStr: string = shippingIntervalOptions.shippingIntervalFrequencies.join(',');
            const prodHasCommonFreqs: boolean = prod.shippingIntervalFrequency === commonFreqsStr;
            const prodHasCommonIntervType: boolean = prod.shippingIntervalType === shippingIntervalOptions.shippingIntervalType;

            if (prodHasCommonFreqs && prodHasCommonIntervType) {
              return (
                <SimpleSubProduct
                  key={prod.id}
                  langStrings={langStrings}
                  product={prod}
                  simpleSubProducts={simpleSubProducts}
                  setSimpleSubProducts={setSimpleSubProducts}
                />
              );
            }

            return null;
          })}
        </div>
      </div>

      <div className="simple-sub-main-sect-two">
        <h3 className="simple-sub-main-sect-num">2</h3>
        <h2 className="simple-sub-main-sect-title">{mainContent.sectionTwoTitle}</h2>
        <p className="simple-sub-main-sect-desc">{mainContent.sectionTwoDesc}</p>

        {shippingIntervalOptions && (
          <select
            className="select simple-sub-main-sect-two-freq"
            value={shippingIntervalOptions.selectedFrequency}
            onChange={handleFrequencyChange}
            aria-label="Delivery Frequency"
          >
            {shippingIntervalOptions.shippingIntervalFrequencies?.map((_freq, idx) => {
              return (
                <option
                  key={idx}
                  value={idx}
                >
                  {langStrings.every} {idx + 1} {shippingIntervalOptions.shippingIntervalType}{langStrings.intervalTypeSuffix}
                </option>
              );
            })}
          </select>
        )}
      </div>
    </div>
  );
};

export default SimpleSubMain;